import { useState, useCallback, useEffect } from 'react';

// We disable this rule since it gives a false error due to the process.env check at the start.
// NODE_ENV will never change at runtime so the hook is guaranteed to execute the same way every time!
/* eslint-disable react-hooks/rules-of-hooks */
const useLottie = () => {
  // We do not want this to load in tests
  if (process.env.NODE_ENV === "test") return false;
  const [isLoaded, setIsLoaded] = useState(false);
  const load = useCallback(() => {
    document.getElementById("web-lottie")?.setAttribute("loaded", "true");
    setIsLoaded(true);
  }, []);
  useEffect(() => {
    let script = document.getElementById("web-lottie");
    if (!script) {
      const pre = document.createElement("script");
      pre.appendChild(document.createTextNode(`
        window._define = window.define
        window.define = null
      `));
      document.head.appendChild(pre);
      script = document.createElement("script");
      script.id = "web-lottie";
      script.setAttribute("loaded", "false");
      script.setAttribute("src", "https://cdn.izettle.com/design-platform/lottie/5.7.3/lottie_light.min.js");
      script.setAttribute("crossorigin", "anonymous");
      script.setAttribute("integrity", "sha512-AovxT5OPANQ5TdCDH2IwdrS15iX7wph2aqm35Zoss8JV0AA1tgdGQxD65NWeeWBmQz1XHXYz8klTBS/C98RQxw==");
      document.head.appendChild(script);
      script.addEventListener("load", () => {
        load();
        const post = document.createElement("script");
        post.appendChild(document.createTextNode(`
          window.define = window._define
          delete window._define
        `));
        document.head.appendChild(post);
      });
    } else if (script.getAttribute("loaded") === "false") {
      script.addEventListener("load", load);
    } else {
      setIsLoaded(true);
    }
    return () => {
      script?.removeEventListener("load", load);
    };
  }, []);
  return isLoaded;
};

export { useLottie };
//# sourceMappingURL=use-lottie.js.map
